import { useState, useEffect } from 'react';
// import { BrowserRouter as Route, useNavigate } from "react-router-dom";
import {useLocation} from 'react-router-dom';
import React, { PureComponent } from 'react';
import {Button, Stack, TextField} from '@mui/material';
import axios from 'axios';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import config from '../config';
function PowerOn() {
      
  const [monitoringStatus, setMonitoringStatus] = useState('Idle');
  const token = localStorage.getItem('token');

  const startMonitoring = async () => {
    try {
      const response = await axios.get(
        config.apis.monitoring.start,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setMonitoringStatus('Monitoring Started');
      console.log('Start Monitoring Response:', response.data);
    } catch (error) {
      console.error('Error starting monitoring:', error);
      setMonitoringStatus('Error Starting Monitoring');
    }
  };
//ab


  const stopMonitoring = async () => {
    try {
      const response = await axios.get(
        config.apis.monitoring.stop,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setMonitoringStatus('Monitoring Stopped');
      console.log('Stop Monitoring Response:', response.data);
    } catch (error) {
      console.error('Error stopping monitoring:', error);
      setMonitoringStatus('Error Stopping Monitoring');
    }
  };

  
  //   try {
  //     const response = await axios.post(
  //       config.apis.monitoring.simulation,
  //       {
  //         apikey: "f0273444-c92f-4853-b52d-663a0f0c25d8",
  //         ip: "10.10.214.251",
  //         read_datetime: "2022-10-20 16:07:00",
  //         read_uid_operation: "2837c1f4-4f55-4f5b-99c9-d8651e2de4af",
  //         read_type: 1,
  //         read_json_data: {
  //           opticalLevel: {
  //             mm1: "4", mm2: "13", mm3: "0", mm4: "0", mm5: "0", mm6: "0",
  //             mm7: "0", mm8: "0", mm9: "0", mm10: "0", mm11: "0", mm12: "0",
  //             mm13: "0", mm14: "0", mm15: "0", mm16: "0", mm17: "0", mm18: "0",
  //             mm19: "0", mm20: "0", mm21: "0", mm22: "0", mm23: "0", mm24: "0",
  //             mm25: "0", mm26: "0", mm27: "0", mm28: "0", mm29: "0", mm30: "0",
  //             mm31: "0", mm32: "0", mm33: "0", mm34: "0", mm35: "0", mm36: "0",
  //             mm37: "0", mm38: "0", mm39: "0", mm40: "0"
  //           },
  //           piezo: {
  //             picco_1_2: "0", picco_2_3: "0", picco_3_4: "0",
  //             picco_4_5: "0", picco_5_6: "0", picco_6_7: "0",
  //             picco_beyond_7: "0"
  //           },
  //           piezoCountersPlusMedia: {
  //             impactsCounter: "0",
  //             averageValue: "255"
  //           },
  //           magnetometer: {
  //             xAxis: "0",
  //             yAxis: "0",
  //             zAxis: "0"
  //           },
  //           anemometer: 0.0,
  //           temperature: -20,
  //           rain: 0,
  //           battery: 13.8,
  //           ioState: {
  //             fcas: "1", fccs: "0", fcai: "0", fcci: "0",
  //             id1: "0", id2: "0", ras: "0", rcs: "0",
  //             rai: "0", rci: "0", rd1: "0", rd2: "0"
  //           },
  //           errorLatchedStates: {
  //             tas: "1", tcs: "1", tai: "1", tci: "1",
  //             taa: "1", mcms: "1", mcmirm: "1"
  //           }
  //         }
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  
  //     console.log('Simulation', response.data);
  //   } catch (error) {
  //     console.error('Error Simulation', error);
  //   }
  // };
  



  return (
    <Box sx={{ padding: '100px', textAlign: 'center' }}>
      <Typography variant="h4" sx={{ marginBottom: '50px' }}>
        Monitoraggio delle eruzioni
      </Typography>

 

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
        <Button
          variant="contained"
          color="success"
          onClick={startMonitoring}
        >
          Avvia Monitoraggio Eruzione
        </Button>

        <Button
          variant="contained"
          color="error"
          onClick={stopMonitoring}
        >
          Ferma Monitoraggio Eruzione
        </Button>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '20px' }}>

       
      </Box>
    </Box>
  );
}


export default PowerOn;